module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Copy.59c3cd6c.svg";